import { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";

/**
 * Dibuja un codigo de barras Code128 en SVG.
 *
 * Code128 lo lee cualquier pistola USB sin configurar nada y no requiere
 * registro GS1. El texto legible va debajo de las barras para poder
 * teclearlo a mano si la etiqueta se raya.
 */
function CodigoBarra({
  valor,
  alto = 60,
  ancho = 2,
  mostrarTexto = true,
  className = "",
}) {
  const svgRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!valor || !svgRef.current) return;

    setError(false);

    try {
      JsBarcode(svgRef.current, String(valor), {
        format: "CODE128",
        height: alto,
        width: ancho,
        displayValue: mostrarTexto,
        fontSize: 14,
        fontOptions: "bold",
        textMargin: 4,
        margin: 6,
        lineColor: "#101828",
        background: "#ffffff",
      });
    } catch (e) {
      // Un valor que Code128 no pueda representar no debe tumbar la vista.
      console.error("No se pudo generar el codigo de barras:", e);
      setError(true);
    }
  }, [valor, alto, ancho, mostrarTexto]);

  if (!valor) {
    return <span className="codigo-barra-vacio">No barcode</span>;
  }

  if (error) {
    return <span className="codigo-barra-vacio">Invalid barcode: {valor}</span>;
  }

  return <svg ref={svgRef} className={`codigo-barra ${className}`} />;
}

export default CodigoBarra;
